import { useState } from 'react';

function Contact() {
  const [status, setStatus] = useState('');
  const [sending, setSending] = useState(false);

  const formatPhone = (value) => {
    const digits = value.replace(/\D/g, '').slice(0, 11);
    if (!digits) return '';
    if (digits.length <= 2) return `(${digits}`;
    if (digits.length <= 6) return `(${digits.slice(0, 2)}) ${digits.slice(2)}`;
    if (digits.length <= 10) {
      return `(${digits.slice(0, 2)}) ${digits.slice(2, 6)}-${digits.slice(6)}`;
    }
    return `(${digits.slice(0, 2)}) ${digits.slice(2, 7)}-${digits.slice(7)}`;
  };

  const handlePhoneInput = (e) => {
    const formatted = formatPhone(e.target.value);
    if (formatted !== e.target.value) {
      e.target.value = formatted;
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const form = e.currentTarget;
    setSending(true);
    setStatus('');

    try {
      const res = await fetch('/send-mail.php', {
        method: 'POST',
        body: new FormData(form),
      });

      const data = await res.json().catch(() => ({}));
      if (!res.ok || !data.success) {
        const msg = data.message || `Erro ao enviar (status ${res.status}).`;
        setStatus(msg);
        return;
      }

      setStatus('Mensagem enviada com sucesso.');
      form.reset();
    } catch (err) {
      setStatus('Nao foi possivel enviar. Tente novamente.');
    } finally {
      setSending(false);
    }
  };

  return (
    <section id="contact" className="section section-cta">
      <div className="container cta-grid">
        <div className="cta-copy reveal">
          <h2>Entre em contato</h2>
          <p>
            Preencha o formulário e descubra como podemos ajudar sua empresa a crescer com segurança e eficiência.
          </p>

          <div className="cta-cards">
            <div className="mini-card reveal">
              <strong>Resposta rápida</strong>
              <span>Retorno via e-mail/WhatsApp</span>
            </div>
            <div className="mini-card reveal">
              <strong>Atendimento humano</strong>
              <span>Sem robôs, sem enrolação</span>
            </div>
          </div>
        </div>

        <form
          id="contactForm"
          className="form reveal"
          action="/send-mail.php"
          method="post"
          encType="multipart/form-data"
          onSubmit={handleSubmit}
        >
          <div className="grid-2">
            <div className="field">
              <label htmlFor="name">Nome*</label>
              <input id="name" name="name" type="text" placeholder="Seu nome" required />
            </div>
            <div className="field">
              <label htmlFor="email">E-mail*</label>
              <input id="email" name="email" type="email" placeholder="voce@email.com" required />
            </div>
          </div>

          <div className="grid-2">
            <div className="field">
              <label htmlFor="phone">WhatsApp*</label>
              <input
                id="phone"
                name="phone"
                type="tel"
                placeholder="(00) 00000-0000"
                inputMode="numeric"
                onInput={handlePhoneInput}
                required
              />
            </div>
            <div className="field">
              <label htmlFor="segment">Segmento</label>
              <select id="segment" name="segment">
                <option value="">Selecione</option>
                <option>Prestador de serviços</option>
                <option>Comércio</option>
                <option>Indústria</option>
                <option>Pessoa física</option>
              </select>
            </div>
          </div>

          <div className="field">
            <label htmlFor="message">Mensagem*</label>
            <textarea id="message" name="message" rows="5" placeholder="Conte brevemente sua necessidade" required></textarea>
          </div>

          <button type="submit" className="btn btn-primary btn-full" disabled={sending}>
            {sending ? 'Enviando...' : 'Enviar mensagem'}
          </button>

          {status && (
            <p className="form-note" role="status" aria-live="polite">{status}</p>
          )}

          <p className="form-note">
            Ao enviar, você concorda em receber retorno sobre sua solicitação. Não enviamos spam.
          </p>
        </form>
      </div>
    </section>
  );
}

export default Contact;
